var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNrg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#00E676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00159 2.5332L11.3332 5.9095L8.00007 9.28374L6.66665 7.93407L8.66667 5.9095L8.00007 5.2345L5.33323 7.93407L8.00007 10.6336L12 6.58418L13.3332 7.93407L8.00007 13.3332L2.6665 7.93407L8.00159 2.5332Z",
    fill: "#212329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNrg);
export default __webpack_public_path__ + "static/media/NRG.68ae87727c408b0629b7a4572d5350c0.svg";
export { ForwardRef as ReactComponent };